import {
  faCircleCheck,
  faClose,
  faXmarkHexagon,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, IconButton, Typography, makeStyles } from '@material-ui/core';

// eslint-disable-next-line import/prefer-default-export
export const useStyle = makeStyles(() => ({
  infoBox: {
    borderRadius: 8,
    backgroundColor: '#E8FBF3',
    paddingLeft: 20,
    paddingRight: 16,
  },
  infoContent: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoBoxIconContent: {
    minWidth: '30px',
    boxSizing: 'inherit',
    display: 'block',
    marginTop: '4px',
  },
  infoBoxIconContentError: {
    minWidth: '30px',
    boxSizing: 'inherit',
    display: 'block',
  },
  infoText: {
    lineHeight: '38px',
    fontSize: '15px',
    fontWeight: 400,
    color: '#0C472C',
  },
  infoIcon: {
    color: '#27AE60',
    width: 24,
    height: 24,
  },
  infoClose: {
    display: 'block',
    boxSizing: 'inherit',
    textAlign: 'right',
  },
  infoContentText: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '12px',
    marginTop: '12px',
    width: 'inherit',
  },
  infoContentTextError: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '14px',
    width: 'inherit',
  },
  infoBoxError: {
    borderRadius: 8,
    backgroundColor: '#FFDCE0',
    paddingLeft: 20,
    paddingRight: 16,
  },
  infoTextError: {
    lineHeight: '22px',
    fontSize: '15px',
    fontWeight: 400,
    color: '#910314',
  },
  infoIconError: {
    color: '#B80016',
    width: 24,
    height: 24,
  },
  infoContentTextCenter: {
    marginTop: '16px',
  },
}));

type Props = {
  isSuccessMessage: boolean;
  isOpen: boolean;
  closeMessage: () => void;
};

const DownloadMessages = ({
  isSuccessMessage,
  isOpen,
  closeMessage,
}: Props): JSX.Element => {
  const classes = useStyle();
  const firstIcon = isSuccessMessage ? faCircleCheck : faXmarkHexagon;
  const messageText = isSuccessMessage
    ? 'Documento descargado con éxito'
    : 'No se ha podido descargar el documento. Intenta nuevamente.';
  const infoIcon = isSuccessMessage ? classes.infoIcon : classes.infoIconError;
  const infoBoxClass = isSuccessMessage
    ? classes.infoBox
    : classes.infoBoxError;
  const infoTextClass = isSuccessMessage
    ? classes.infoText
    : classes.infoTextError;
  const classCenterContent = !isSuccessMessage
    ? classes.infoContentTextCenter
    : '';
  const classIconContent = isSuccessMessage
    ? classes.infoBoxIconContent
    : classes.infoBoxIconContentError;
  const classInfoContentText = isSuccessMessage
    ? classes.infoContentText
    : classes.infoContentTextError;

  return (
    <>
      {isOpen && (
        <Grid
          container
          item
          spacing={1}
          alignItems="center"
          className={infoBoxClass}
        >
          <Grid
            container
            item
            spacing={1}
            alignItems="center"
            className={classes.infoContent}
          >
            <Grid className={classInfoContentText}>
              <Grid item xs={1} className={classIconContent}>
                <FontAwesomeIcon className={infoIcon} icon={firstIcon} />
              </Grid>
              <Grid item xs={10} className={classCenterContent}>
                <Grid>
                  <Typography
                    className={infoTextClass}
                    data-testid="typography-message-text"
                  >
                    {messageText}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item xs={1} className={classes.infoClose}>
                <IconButton
                  onClick={closeMessage}
                  id="sales-web-download-files-btn"
                  data-testid="close-download-btn"
                >
                  <FontAwesomeIcon className={infoIcon} icon={faClose} />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default DownloadMessages;
